import { useState } from "react";
import { useSetRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { useMenu } from "@/comn/features/config/MenuConfig";
import { Icon } from "@/comn/components";
import { storeState } from "@/comn/features/recoil";
import { defaultStoreState } from "@/comn/features/recoil/storeState";

const _map = (obj: any, ary: any, _parents: any = {}) => {
    ary.forEach((_: any) => {
        obj[_["menuId"]] = { ..._, _parents };
        if (Array.isArray(_.children)) {
            _map(obj, _.children, { ..._parents, [_["menuLvl"]]: _["menuId"] });
        }
    });
};

const SNBItem = (props: any) => {
    const { menuNm, children, menuId, menuUrlAddr, current, isLeafYn, menuLvl } = props;

    const navigate = useNavigate();
    const setStore = useSetRecoilState(storeState);

    const [open, setOpen] = useState(Object.values(current._parents || {}).includes(menuId));

    const handleClickItem = () => {
        if (children) setOpen((prev: any) => !prev);
        if (menuUrlAddr) {
            if (process.env.REACT_APP_BASE === menuUrlAddr.slice(0, 5)) {
                setStore(defaultStoreState);
                navigate(`${menuUrlAddr}`);
            } else {
                const origin = window.location.origin;
                window.location.href = origin + menuUrlAddr;
            }
        }
    };

    return (
        <li className="flex flex-col">
            <button
                aria-current={current?.menuId === menuId ? "page" : "false"}
                onClick={handleClickItem}
                className={classNames(
                    "group min-h-[2.5rem] p-2 flex text-lg items-center justify-between rounded hover:bg-gray/10 dark:hover:bg-white/5",
                    open ? "text-black font-semibold dark:text-white" : "text-gray dark:text-lightgray",
                    "aria-[current=page]:text-primary aria-[current=page]:font-semibold dark:aria-[current=page]:text-primary",
                )}
            >
                <div className="flex text-left flex-1">
                    {menuLvl > 3 && isLeafYn === "Y" && <span className="mr-2">·</span>}
                    <span className="group-aria-[current=page]:underline">{menuNm}</span>
                </div>
                {Boolean(children) && (
                    <Icon icon="down" size="xs" className={classNames("transition", open && "rotate-180")} />
                )}
            </button>

            {open && Array.isArray(children) && (
                <ul className="flex flex-col pl-2">
                    {children.map((child) => {
                        const { menuId, menuNm } = child;
                        return <SNBItem key={menuId + menuNm} current={current} {...child} />;
                    })}
                </ul>
            )}
        </li>
    );
};

export const NavigationTabMenu = () => {
    const { title, data, current } = useMenu();

    return (
        <div className="px-4">
            <div className="text-gray text-xl items-center flex min-h-[2.5rem] p-2 font-semibold dark:text-lightgray">
                {title}
            </div>
            {Array.isArray(data.children) && (
                <ul className="flex flex-col">
                    {data.children.map((child: any) => {
                        const { menuId, menuNm } = child;
                        return <SNBItem key={menuId + menuNm} current={current} {...child} />;
                    })}
                </ul>
            )}
        </div>
    );
};
